/**
 * 問い合わせフォーム制御
 */
import $ from 'jquery';
import xss from 'xss';
import validator from 'validator';
import utils from '@/_modules/utils';

class _contactForm {

  constructor() {}

  /**
   * 初期化
   */
  once(vNames) {
    this.container = document.getElementById('c-container');
    this.container.classList.add('c-contact--form');

    this.vNames = vNames;

    this.isValidated = false;
    this.isConfirm = false;
    this.isSend = false;
    this.isError = false;
    this.errMsgs = {};
    this.formResult = {};
    this.formValue = {};

    // 確認するボタン
    this.bindConfirm = this.onConfirm.bind(this);
    this.btnConfirm = document.getElementById('c-btnConf');
    this.btnConfirm.addEventListener('click', this.bindConfirm);

    // 送信するボタン
    this.bindSend = this.onSend.bind(this);
    this.btnSend = document.getElementById('c-btnSend');
    this.btnSend.addEventListener('click', this.bindSend);

    // 修正ボタン
    this.bindBack = this.onBack.bind(this);
    this.btnBack = document.getElementById('c-btnBack');
    this.btnBack.addEventListener('click', this.bindBack);

    // wpのcontactForm7の送信を止める
    const wpcf7Elm = document.querySelector('.wpcf7');
    //console.log(wpcf7Elm);
    wpcf7Elm.addEventListener('wpcf7mailsent', this.onCF7Comp, false);
    wpcf7Elm.addEventListener('wpcf7invalid', this.onCF7Invalid, false);
    wpcf7Elm.addEventListener('wpcf7spam', this.onCF7Spam, false);
  }

  start() {

  }

  // エラーチェック => 確認画面
  onConfirm(e) {
    e.preventDefault();
    if (this.isConfirm) return;
    this.isConfirm = true;

    // エラーメッセージを消す
    this.hideErrors();

    // 入力チェック
    for (let name in this.vNames) {
      if (typeof(name) !== 'string') continue;
      let value = '';
      let result = '';
      const el = document.getElementById(`usr-${name}`);
      if (this.vNames[name].type === 'text'
        || this.vNames[name].type === 'textarea') {
        value = el.value;
        result = el.value;
      } else if (this.vNames[name].type === 'radio'
        || this.vNames[name].type === 'checkbox') {
        value = [];
        result = '';
        const btns = el.querySelectorAll(`input[type=${this.vNames[name].type}]`);
        btns.forEach((btn, i) => {
          if (btn.checked) {
            value.push(i);
            if (result) result += ', ';
            result += btn.value;
          }
        });
      } else if (this.vNames[name].type === 'select') {
        value = el.selectedIndex;
        result = el.value;
      }

      // 入力内容を保持
      this.formResult[name] = result; //確認画面 表示用
      this.formValue[name] = value;

      // 入力チェック エラーの場合はisError=true
      this.validate(this.vNames[name], name, value);
    }

    if (this.isError) {
      // 入力エラーあり
      this.onFails();
    } else {
      // 入力エラーなし
      this.onPasses();
    }
  }

  validate(vNames, name, value) {
    if (!vNames.rule) return;

    for (let i in vNames.rule) {
      const rule = vNames.rule[i];

      if (rule === 'required') {
        if (validator.isEmpty(value, {ignore_whitespace: true})) {
          // 未入力
          this.isError = true;
          this.errMsgs[name] = `${vNames.name}を入力してください。`;
          break;
        }
      } else if (rule === 'required_arr') {
        if (value.length === 0) {
          this.isError = true;
          this.errMsgs[name] = `${vNames.name}を選択してください。`;
          break;
        }
      } else if (rule === 'required_select') {
        if (value === 0) {
          this.isError = true;
          this.errMsgs[name] = `${vNames.name}を選択してください。`;
          break;
        }
      }

      if (rule.indexOf('max:') > -1) {
        const max = rule.split(':');
        if (!validator.isLength(value, {min: 0, max: max[1]})) {
          // 文字数超え
          this.isError = true;
          this.errMsgs[name] = `${vNames.name}を${max[1]}文字以下で入力してください。`;
          break;
        }
      }

      if (rule === 'email') {
        if (!validator.isEmail(value)) {
          // メールアドレスが正しくない
          this.isError = true;
          this.errMsgs[name] = `メールアドレスが正しくありません`;
          break;
        }
      }

      if (rule.indexOf('equal:') > -1) {
        const equal = rule.split(':');
        const elEqual = document.getElementById(`usr-${equal[1]}`);
        if (!validator.equals(value, elEqual.value)) {
          this.isError = true;
          this.errMsgs[name] = `メールアドレスが一致していません`;
          break;
        }
      }
    }
  }

  hideErrors() {
    this.isError = false;
    this.errMsgs = {};

    document.getElementById('err-lead').style.display = 'none';

    for (let name in this.vNames) {
      if (typeof(name) !== 'string') continue;
      document.getElementById(`err-${name}`).textContent = '';
      document.getElementById(`err-${name}`).style.display = 'none';
    }
  }

  // バリデーションError
  onFails() {
    this.isConfirm = false;
    this.isValidated = false;

    document.getElementById('err-lead').style.display = 'block';

    for (let name in this.errMsgs) {
      if (typeof(name) !== 'string') continue;
      document.getElementById(`err-${name}`).textContent = this.errMsgs[name];
      document.getElementById(`err-${name}`).style.display = 'block';
    }

    this.pageTop();
  }

  // バリデーションOK
  onPasses() {
    this.isConfirm = true;
    this.isValidated = true;

    // 確認画面にデータを表示する：本当のフォームにデータ入力する
    for (let name in this.vNames) {
      if (typeof(name) !== 'string') continue;

      const conf = document.getElementById(`conf-${name}`);
      if (conf) conf.textContent = xss(this.formResult[name]);

      // contact formに値を写す
      const el = document.getElementById(`wp-${name}`);
      if (this.vNames[name].type === 'text'
        || this.vNames[name].type === 'textarea') {
        document.getElementById(`wp-${name}`).value = xss(this.formValue[name]);
      } else if (this.vNames[name].type === 'radio'
        || this.vNames[name].type === 'checkbox') {

        const btns = el.querySelectorAll(`input[type=${this.vNames[name].type}]`);
        const values = this.formValue[name];
        for (let i = 0; i < values.length; i++) {
          btns[values[i]].checked = true;
        }
      } else if (this.vNames[name].type === 'select') {
        el.selectedIndex = this.formValue[name];
      }
    }

    // スクロール
    this.pageTop();

    // フォームを消す
    gsap.set(document.getElementById('c-form'), {
      display: 'none',
    });

    // 確認画面を表示する
    this.container.classList.add('c-contact--confirm');
    this.container.classList.remove('c-contact--form');
    gsap.set(document.getElementById('c-conf'), {
      display: 'block',
    });
  }

  // 修正するボタン
  onBack(e) {
    e.preventDefault();
    if (!this.isValidated) return;
    this.isConfirm = false;
    this.isValidated = false;
    this.hideErrors();

    // スクロール
    this.pageTop();

    // 確認画面を消す
    gsap.set(document.getElementById('c-conf'), {
      display: 'none',
    });

    // フォームを表示する
    this.container.classList.add('c-contact--form');
    this.container.classList.remove('c-contact--confirm');
    gsap.set(document.getElementById('c-form'), {
      display: 'block',
    });
  }

  // 送信完了で完了画面へ遷移する
  onSend(e) {
    e.preventDefault();
    if (this.isSend) return;
    this.isSend = true;

    document.getElementById('wp-submit').click();

    /*
    // スクロール
    this.pageTop();

    // 確認画面を消す
    gsap.set(document.getElementById('c-conf'), {
      display: 'none',
    });

    // 完了画面を表示
    gsap.set(document.getElementById('c-complete'), {
      display: 'block',
    });
    */
  }

  /**
   * 送信完了
   */
  onCF7Comp(e) {
    console.log(e, '送信されました。');
    //location.href='/';
  }

  onCF7Invalid(e) {
    console.log(e, 'エラーがあります。');
  }

  onCF7Spam(e) {
    console.log(e, 'スパム');
    document.getElementById('js-err-spam').style.display = 'block';
  }

  // 入力フォームの先頭へスクロール
  pageTop() {
    gsap.to(window, {
      duration: 0.7,
      scrollTo: {
        y: 0,
        autoKill: false,
      },
      ease: Power3.easeOut
    });
  }
}

const contactForm = new _contactForm();

export default contactForm;